// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1Lvdh","footer":"ModalFilter_footer__12dM9"};